import React from 'react';
import styled from 'styled-components';
import NextechCard from './NextechCard';

const ProductSalesWhyNextech = () => {
  const offers = [
    {
      icon: 'FaTools',
      title: 'PLM Expertise',
      description: 'Comprehensive understanding of PLM products and business requirements.',
    },
    {
      icon: 'FaClipboardCheck',
      title: 'Teamcenter Proficiency',
      description: 'Expertise in Siemens Teamcenter PLM product suite.',
    },
    {
      icon: 'FaChartLine',
      title: 'Process & Productivity Focus',
      description: 'Commitment to improving processes and productivity.',
    },
    {
      icon: 'FaBullseye',
      title: 'Maximizing Profitability',
      description: 'Focus on maximizing profitability and ROI.',
    },
    {
      icon: 'FaRoad',
      title: 'Lean Methodology',
      description: 'Dedication to managing product complexity with Lean Methodology.',
    },
    {
      icon: 'FaPlusCircle',
      title: 'Proven Implementation Success',
      description: 'Reliable implementation services ensuring efficient and effective transformation on the Teamcenter platform.',
    },
  ];

  return (
    
      <Container>
        <SectionTitle>Why Choose <span>NexTech</span> for Product Sales?</SectionTitle>
        <SectionSubtitle>
          NexTech is your trusted partner for PLM solutions, providing expertise in Teamcenter and commitment to your business success.
        </SectionSubtitle>
        <OfferCards>
          {offers.map((offer, index) => (
            <NextechCard
              key={index}
              icon={offer.icon}
              title={offer.title}
              description={offer.description}
            />
          ))}
        </OfferCards>
      </Container>
 
  );
}

export default ProductSalesWhyNextech;



const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 3.1em;
 font-family: "Poppins", system-ui;  
 color: #00cbf1;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: left;
  position: relative;

  span {
    color: #f0faff;
  }

  @media (max-width: 768px) {
    font-size: 2.2em;
  }

  @media (max-width: 480px) {
    font-size: 2em;
    text-align: left;
    margin-left:10px;
    line-height:1.6;
  }
`;

const SectionSubtitle = styled.p`
  font-family: "Poppins", system-ui;
  font-size: 1.2em;
  font-weight: 300;
  color: #f0faff;
  line-height: 1.71;
  margin-bottom: 40px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    text-align: justify;
    font-size: 0.9em;
    margin:0px 10px 20px 10px;
  }
`;

const OfferCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
`;
